import { Store } from '@reduxjs/toolkit';
import {
  StoreType,
  ReducersInjectorWithState,
  store,
} from '@wajeez-web/stores/base';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import commonReducer from './common/slices';
import { CommonState } from './common/types';
import { NavigationState } from './navigation/types';
import navigationReducer from './navigation/slices';

export let commonStore: StoreType<{
  common: CommonState;
  navigation: NavigationState;
}>;

// export type StoreType = typeof store;
export type CommonDispatch = typeof commonStore.dispatch;
export type CommonStoreState = ReturnType<typeof commonStore.getState>;
export const useCommonDispatch = () => useDispatch<CommonDispatch>();
export const useCommonSelector: TypedUseSelectorHook<CommonStoreState> =
  useSelector;
export const getCommonState = (store: Store) =>
  store.getState() as CommonStoreState;

export const injectCommonReducers: ReducersInjectorWithState<
  CommonStoreState
> = () => {
  return [
    {
      name: 'common',
      reducer: commonReducer,
    },
    {
      name: 'navigation',
      reducer: navigationReducer,
    },
  ];
};
